$ ->
  $("a.btn.btn-default.extra_log_entry").click ->
    $(".extra_log_entry").toggleClass("hidden")